// Shared site content & assets for KAT Transportation Services
export const PHONE_DISPLAY = "703-296-8036";
export const PHONE_TEL = "+17032968036";


export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const TAGLINES = ["Your Trusted Ride, Every Time", "Reliable Rides, Family Care"];

export const IMAGES = {
  hero: "/hero-car.jpg",
  airport: "https://images.unsplash.com/photo-1765446607390-aa61ae857a50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBibGFjayUyMHNlZGFuJTIwZHJpdmluZyUyMHN1bnNldHxlbnwwfHx8fDE3ODUyMTYwMDB8MA&ixlib=rb-4.1.0&q=85",
  medical: "https://images.unsplash.com/photo-1634150869160-9f45d67fd9e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxlbGRlcmx5JTIwcGVyc29uJTIwaW4lMjBjYXJ8ZW58MHx8fHwxNzgzNjY4NTY5fDA&ixlib=rb-4.1.0&q=85",
  driver: "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  interior: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBibGFjayUyMGNhciUyMGludGVyaW9yJTIwbGVhdGhlcnxlbnwwfHx8fDE3ODUyMTYxOTd8MA&ixlib=rb-4.1.0&q=85",
  terminal: "https://images.unsplash.com/photo-1629221731259-4f0760e3ee89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxhaXJwb3J0JTIwdGVybWluYWwlMjBuaWdodCUyMGx1eHVyeSUyMHRyYXZlbHxlbnwwfHx8fDE3ODUyMTYxOTZ8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "airport",
    num: "01",
    title: "Airport Transportation",
    short: "Dulles • Reagan National • BWI",
    desc: "Reliable pickup and drop-off to and from every major regional airport. We track your flight in real time so we're always there on time — backed by our on-time guarantee.",
    points: ["Live flight-time tracking", "On-time guarantee", "Dulles, Reagan National & BWI"],
    image: "airport",
    featured: true,
  },
  {
    id: "medical",
    num: "02",
    title: "Doctor & Medical Rides",
    short: "Safe, punctual, patient",
    desc: "Dependable transportation for medical visits and appointments — with extra care and patience for seniors and anyone needing a helping hand.",
    points: ["Door-to-door assistance", "Senior-friendly care", "Never rushed"],
    image: "medical",
    featured: false,
  },
  {
    id: "personal",
    num: "03",
    title: "Personal & Local Rides",
    short: "Errands, shopping & more",
    desc: "Your friendly local ride for everyday life — errands, shopping trips, and general rides around Haymarket and beyond.",
    points: ["Errands & shopping", "Around town", "Familiar, trusted driver"],
    image: "interior",
    featured: false,
  },
];

export const ADD_ONS = [
  "School Pickup & Drop-off",
  "Event Transportation",
  "Grocery Runs",
  "Out-of-Town Trips",
];

export const WHY = [
  { title: "Always On Time", desc: "Punctuality is our promise. We plan every route so you're never left waiting." },
  { title: "Family Care", desc: "A family-operated service that treats every client like one of our own." },
  { title: "Local Knowledge", desc: "Years of driving Haymarket roads means faster, smoother, smarter routes." },
  { title: "Personal & Trusted", desc: "Not an app full of strangers — the same friendly, familiar driver every time." },
  { title: "Senior-Friendly Care", desc: "We specialize in caring for our 55+ neighbors — patient, gentle, and attentive from door to door. We know how to look after elderly riders, so getting where you need to be is one less thing to worry about." },
];

export const TESTIMONIALS = [
  { name: "Your Review Here", location: "Haymarket, VA", quote: "This space is reserved for your words. Share your experience riding with KAT Transportation and we'll feature it right here." },
  { name: "Your Review Here", location: "Gainesville, VA", quote: "Loved your ride? We'd be honored to showcase your feedback for future neighbors and clients to see." },
  { name: "Your Review Here", location: "Bristow, VA", quote: "Tell the community why you trust Rui and KAT Transportation for your rides. Your review goes here." },
];
